import classNames from 'classnames';
import { BtnThreeProps } from 'eco-design-micro/props/btn/BtnThreeProps';
import { HorizontalProps } from 'eco-design-micro/props/position/const';
import EcoButton from 'eco-design/base/eco-button';
import React from 'react';
import './index.scss';

export interface EcoButtonThreeProps extends BtnThreeProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 展示位置
     *
     * left 靠左
     *
     * center 居中
     *
     * right 靠右
     */
    layoutBtnThree?: HorizontalProps;
}

/**
 *
 * 三按钮
 */
const EcoButtonThree: React.FC<EcoButtonThreeProps> = (reset) => {
    const props = reset || {};
    const prefixCls = `eco-button-three`;
    const classes = classNames(prefixCls, {
        [`${props.className}`]: props.className,
        [`${prefixCls}-layout-${props.layoutBtnThree}`]: props.layoutBtnThree,
    });

    return (
        <div className={classes}>
            {!!props.lChildren && (
                <EcoButton
                    lType={props.lType}
                    lSize={props.lSize}
                    lRadius={props.lRadius}
                    lTheme={props.lTheme}
                    lHref={props.lHref}
                    lFontColor={props.lFontColor}
                    lBgColor={props.lBgColor}
                    lBorderColor={props.lBorderColor}
                    lChildren={props.lChildren}
                    lIsWithRightArrow={props.lIsWithRightArrow}
                    lDataLayer={props.lDataLayer}
                ></EcoButton>
            )}
            {!!props.cChildren && (
                <EcoButton
                    lType={props.cType}
                    lSize={props.cSize}
                    lRadius={props.cRadius}
                    lTheme={props.cTheme}
                    lHref={props.cHref}
                    lFontColor={props.cFontColor}
                    lBgColor={props.cBgColor}
                    lBorderColor={props.cBorderColor}
                    lChildren={props.cChildren}
                    lIsWithRightArrow={props.cIsWithRightArrow}
                    lDataLayer={props.cDataLayer}
                ></EcoButton>
            )}
            {!!props.rChildren && (
                <EcoButton
                    lType={props.rType}
                    lSize={props.rSize}
                    lRadius={props.rRadius}
                    lTheme={props.rTheme}
                    lHref={props.rHref}
                    lFontColor={props.rFontColor}
                    lBgColor={props.rBgColor}
                    lBorderColor={props.rBorderColor}
                    lChildren={props.rChildren}
                    lIsWithRightArrow={props.rIsWithRightArrow}
                    lDataLayer={props.rDataLayer}
                ></EcoButton>
            )}
        </div>
    );
};

export default EcoButtonThree;
